import React from 'react';
import Typography from '@material-ui/core/Typography';
let facebookImg = require('../../src/assets/img/linkToFanPageFacebook.png')
const ContactoPage = () => (
  <div>
    <Typography variant="display2" color='caption'
                style={{color: '#3A3380', fontSize: '2rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem'}}>
      Contacto
    </Typography>
    <Typography variant="subheading" gutterBottom
                style={{color: 'rgba(0, 0, 0, 0.54)', fontSize: '1.3rem', textAlign: 'center'}}>
      Puede contactarse con nosotros a través de nuestra página de facebook:
    </Typography>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
      <a href="https://www.facebook.com/historiArg1810/" target="_blank">
        <img src={facebookImg} alt=""/>
      </a>
      <Typography variant="subheading" gutterBottom
                  style={{color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem', }}>
        O por nuestro mail: historiarg@gmail.com
      </Typography>
    </div>
  </div>
)

export default ContactoPage



// WEBPACK FOOTER //
// ./src/pages/contacto.js